import * as React from 'react';
import * as styles from './PlacingPeriodTitle.css';

export const PlacingPeriodTitle = () => {
  return <div className={styles['wrapper']}>Срок размещения</div>;
};
